import { render, staticRenderFns } from "./ImportLayoutEditor.vue?vue&type=template&id=cf572956"
import script from "./ImportLayoutEditor.vue?vue&type=script&lang=js"
export * from "./ImportLayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./ImportLayoutEditor.vue?vue&type=style&index=0&id=cf572956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports